import { get } from 'lodash';
import { createSelector } from 'reselect';

const allIdsSelector = state => get( state, 'suggestedDomains.allIds', [] );
const byIdSelector = state => get( state, 'suggestedDomains.byId', {} );

export const suggestedDomainsIsLoadingSelector = state => get( state, 'suggestedDomains.isLoading', false );
export const suggestedDomainsParamsSelector = state => get( state, 'suggestedDomains.params', null );
export const suggestedDomainsFilterParamsSelector = state => get( state, 'suggestedDomains.filterParams', null );
export const suggestedDomainsErrorsSelector = state => get( state, 'suggestedDomains.domainErrors', {} );

// Org Domains of suggested domains
export const suggestedDomainsOrgDomainsIsLoadingSelector = state => get( state, 'suggestedDomains.orgDomainsIsLoading', false );
export const suggestedDomainsOrgDomainsSelector = state => get( state, 'suggestedDomains.orgDomains', null );
export const suggestedDomainsOrgDomainsParamsSelector = state => get( state, 'suggestedDomains.orgDomainsParams', null );

// Pagination
export const suggestedDomainsCurrentPageSelector = state => get( state, 'suggestedDomains.pagination.currentPage', 1 );
export const suggestedDomainsTotalPagesSelector = state => get( state, 'suggestedDomains.pagination.totalPages', 1 );
export const suggestedDomainsTotalItemSelector = state => get( state, 'suggestedDomains.pagination.totalItemCount', 0 );

export const suggestedDomainsSelector = createSelector(
    allIdsSelector,
    byIdSelector,
    ( allIds, suggestedDomainsMap ) => allIds.map( id => suggestedDomainsMap[id] )
);
